import { useComponentSize, useMutableRef } from '@carnica/utils/hooks';
import { useCallback, useEffect, useMemo, useRef } from 'react';
import { calculateBlurOffset } from "./utils";
export var useScrollBlur = function useScrollBlur(_ref) {
  var _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'default' : _ref$position,
    wrapperRef = _ref.wrapperRef,
    tabWidths = _ref.tabWidths,
    offset = _ref.offset;
  var positionRef = useMutableRef(position);
  var offsetRef = useMutableRef(offset);
  var blurPositionRef = useRef({
    left: 0,
    right: 0
  });
  var blurAreaLeftRef = useRef(null);
  var blurAreaRightRef = useRef(null);
  var ignoreRef = useRef(false);
  var _useComponentSize = useComponentSize(wrapperRef),
    width = _useComponentSize.width;
  var setOffsetAttribute = useCallback(function (offsetMap) {
    var setRefAttr = function setRefAttr(side, value) {
      var _ref$current;
      var ref = side === 'left' ? blurAreaLeftRef : blurAreaRightRef;
      var sideOffset = offsetRef.current ? offsetRef.current[side] || 0 : 0;
      (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.style.setProperty('--tabbar-blur-area-offset', "".concat(value - sideOffset, "px"));
    };
    setRefAttr('left', offsetMap.left);
    setRefAttr('right', offsetMap.right);
  }, []);
  var generateOffset = useCallback(function () {
    var _wrapperRef$current;
    if (ignoreRef.current) {
      return;
    }
    var blurOffset = calculateBlurOffset(((_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : _wrapperRef$current.scrollLeft) || 0, wrapperRef, positionRef.current);
    blurPositionRef.current = blurOffset;
    setOffsetAttribute(blurOffset);
  }, []);
  var totalWidth = useMemo(function () {
    return (tabWidths || []).reduce(function (acc, val) {
      return acc + val;
    }, 0);
  }, [tabWidths]);

  // eslint-disable-next-line consistent-return
  useEffect(function () {
    var _wrapperRef$current2;
    (_wrapperRef$current2 = wrapperRef.current) === null || _wrapperRef$current2 === void 0 ? void 0 : _wrapperRef$current2.addEventListener('scroll', generateOffset);
    generateOffset();
    return function () {
      var _wrapperRef$current3;
      return (_wrapperRef$current3 = wrapperRef.current) === null || _wrapperRef$current3 === void 0 ? void 0 : _wrapperRef$current3.removeEventListener('scroll', generateOffset);
    };
  }, []);
  useEffect(function () {
    generateOffset();
  }, [totalWidth, width]);
  var setBlurOffset = useCallback(function (callback) {
    ignoreRef.current = true;
    var blurOffset = callback(blurPositionRef.current);
    blurPositionRef.current = blurOffset;
    setOffsetAttribute(blurOffset);
    setTimeout(function () {
      ignoreRef.current = false;
    }, 300);
  }, []);
  return useMemo(function () {
    return {
      blurAreaRefs: {
        left: blurAreaLeftRef,
        right: blurAreaRightRef
      },
      setBlurOffset: setBlurOffset
    };
  }, []);
};